module.exports = __webpack_public_path__ + "img/cardDesign.1e782128.jpg";